<template>
    <div class="section-light skills" id="skills">
        <div class="container">
            <div class="columns is-multiline">
                <div class="column is-12 about-me">
                    <h1 class="title has-text-centered section-title">Skills</h1>
                    <div class="subtitle has-text-centered click-to-reveal" @click="skillsRise"
                        data-aos="zoom-in" data-aos-delay="1200" data-aos-duration="600" data-aos-once="true">
                        <div class="button is-outlined">Click here to reveal skill-level</div>
                    </div>
                </div>
                <div class="column is-6" data-aos="fade-in" data-aos-easing="linear">
                    <h1>HTML + CSS + JavsScript</h1>
                    <progress class="progress" :value="skills.html.val" max="100"></progress>
                    <h1>Node.js</h1>
                    <progress class="progress" :value="skills.node.val" max="100"></progress>
                    <h1>VueJS + Nuxt</h1>
                    <progress class="progress" :value="skills.vue.val" max="100"></progress>
                    <h1>Python + Pandas + scikit-learn</h1>
                    <progress class="progress" :value="skills.python.val" max="100"> </progress>
                </div>
                <div class="column is-6" data-aos="fade-in" data-aos-easing="linear">
                    <h1>Design Thinking <span class="is-hidden-tablet-only">& human-centered Design</span> </h1>
                    <progress class="progress" :value="skills.design.val" max="100"></progress>
                    <h1>SEO</h1>
                    <progress class="progress" :value="skills.seo.val" max="100"></progress>
                    <h1>Excel</h1>
                    <progress class="progress" :value="skills.excel.val" max="100"></progress>
                    <h1>Business Development</h1>
                    <progress class="progress" :value="skills.business.val" max="100"></progress>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Skills",
        data: function() {
            return {
                skills: {
                    'html': {val: 0, max: 95},
                    'vue': {val: 0, max: 89},
                    'node': {val: 0, max: 75},
                    'python': {val: 0, max: 68},
                    'seo': {val: 0, max: 67},
                    'design': {val: 0, max: 78},
                    'excel': {val: 0, max: 95},
                    'business': {val: 0, max: 78},
                }
            }
        },
        methods: {
            skillsRise() {
                setInterval(() => {
                    for(let skill in this.skills) {
                        if(this.skills[skill].val < this.skills[skill].max)
                            this.skills[skill].val += 0.3;
                    }
                }, 1)
            },
        }
    }
</script>

<style scoped>
    .click-to-reveal {
        cursor: pointer;
    }

</style>
